import React, { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';

const ThreadModal = ({ id, onClose }) => {
    const { instance, accounts } = useMsal();
    const [content, setContent] = useState({ loading: true, data: null });
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchThread = async () => {
            try {
                const email = accounts[0]?.username;
                if (!email) {
                    setError('No user is logged in');
                    return;
                }

                // const response = await axios.get(`https://graph.microsoft.com/v1.0/users/${email}/messages/${id}`);
                const response = await axios.get(
                    `https://api.gabrielny.com:8080/ai_zohoProxy.php?query=getEmail&threadId=${encodeURIComponent(id)}&userEmail=${encodeURIComponent(email)}`
                );


                setContent({ loading: false, data: response.data });
            } catch (err) {
                console.error(err);
                setError('Failed to fetch thread content');
                setContent({ loading: false, data: null });
            }
        };

        fetchThread();
    }, [id, instance, accounts]);

    return (
        <div className="fixed inset-0 z-[200] bg-black/50 backdrop-blur-sm flex items-center justify-center p-6" onClick={onClose}>
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
                <div className="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-xl">
                    <h3 className="font-bold text-lg text-gray-800">Email Thread Preview</h3>
                    <button onClick={onClose} className="p-2 hover:bg-gray-200 rounded-full transition-colors">
                        X
                    </button>
                </div>
                <div className="flex-1 overflow-y-auto p-6">
                    {content.loading ? (
                        <div className="flex items-center justify-center h-64">Loading content...</div>
                    ) : error ? (
                        <div className="text-red-500">{error}</div>
                    ) : (
                        <div className="prose prose-sm max-w-none">
                            <div className="mb-6 pb-4 border-b">
                                <p className="text-xl font-bold text-blue-900">{content.data.subject}</p>
                                <p className="text-gray-500">
                                    From: {content.data.sender?.emailAddress?.name} ({content.data.sender?.emailAddress?.address})
                                </p>
                                <p className="text-gray-500">
                                    To: {content.data.toRecipients?.map(r =>
                                    r.emailAddress.name
                                        ? `${r.emailAddress.name} (${r.emailAddress.address})`
                                        : r.emailAddress.address
                                ).join(', ') || '—'}
                                </p>
                                {content.data.ccRecipients?.length > 0 && (
                                    <p className="text-gray-500">
                                        CC: {content.data.ccRecipients.map(r =>
                                        r.emailAddress.name
                                            ? `${r.emailAddress.name} (${r.emailAddress.address})`
                                            : r.emailAddress.address
                                    ).join(', ')}
                                    </p>
                                )}
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: content.data.body?.content }} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ThreadModal;
